// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__N1kNS","calendarButtons":"ClockData_calendarButtons__11BJG"};